import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, inject, OnDestroy, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { selectProfileUser } from 'src/app/store/selectors/authentication.selectors';
import { DashboardFacade } from 'src/app/views/dashboard/dashboard.facade';
import { HeaderFacade } from './header.facade';

@Component({
  selector: 'nobis-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('expandContent', [
      state('false', style({ width: '0px' })),
      state('true', style({ width: '100%' })),
      transition('true <=> false', animate('300ms ease-in-out')),
    ])
  ],
})
export class HeaderComponent implements OnDestroy {
  private store = inject(Store)
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);
  protected user$ = this.store.select(selectProfileUser);
  protected facade = inject(HeaderFacade);
  private facadeDashboard = inject(DashboardFacade)
  protected isMenuOpen$ = this.facade.isOpenChanges;
  private destroy$ = new Subject<void>();

  constructor() {
    this.isMenuOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => {
      if (isOpen) {
        this.renderer.addClass(this.document.body, 'no-scroll');
      } else {
        this.renderer.removeClass(this.document.body, 'no-scroll');
      }
    });
  }

  protected menuOpen() {
    this.facade.toggleOpenStatus();
  }

  protected handleLogOut(): void {
    this.facadeDashboard.logOut();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.renderer.removeClass(this.document.body, 'no-scroll');
  }
}




